var _style, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera85(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "camera-85_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1161.1 1161.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".camera-85_svg__st8{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 580.6,
    cy: 580.6,
    r: 565.6,
    fill: "#717aba",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M580.6 458.2c-89.4 0-161.9 72.5-161.9 161.9S491.2 782 580.6 782s161.9-72.5 161.9-161.9S670 458.2 580.6 458.2zm90.2 252.2c-11.7 11.7-25.4 20.9-40.6 27.4-15.7 6.6-32.4 10-49.7 10s-33.9-3.4-49.7-10c-15.2-6.4-28.9-15.6-40.6-27.4-11.7-11.7-20.9-25.4-27.4-40.6-6.7-15.7-10-32.4-10-49.7 0-17.2 3.4-34 10-49.7 6.4-15.2 15.6-28.8 27.4-40.6 11.7-11.7 25.4-20.9 40.6-27.4 15.7-6.6 32.4-10 49.7-10s33.9 3.4 49.7 10c15.2 6.4 28.8 15.6 40.6 27.4 11.7 11.7 20.9 25.4 27.4 40.6 6.6 15.7 10 32.4 10 49.7 0 17.3-3.4 34-10 49.7-6.5 15.2-15.7 28.9-27.4 40.6zM721.5 444.7v2.1c-.1-.7-.1-1.4-.1-2.1 0-.7.1-1.4.1-2.1v2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M832.3 427.5h-78c-8.1-45.1-47.6-79.3-95-79.3H501.8c-47.4 0-86.8 34.3-95 79.3h-78c-9.5 0-17.2 7.7-17.2 17.2v374.8c0 9.5 7.7 17.2 17.2 17.2h503.5c9.5 0 17.2-7.7 17.2-17.2V444.7c0-9.5-7.7-17.2-17.2-17.2zm-17.2 374.8H346V461.8h76.5c4.6 0 8.8-1.8 11.9-4.8 3.1-2.9 5.1-7 5.3-11.6v-.8-.8c.1-5.6.9-11.1 2.4-16.3 7.5-26 31.4-45 59.8-45h157.6c28.3 0 52.3 19 59.8 45 1.4 4.8 2.2 9.9 2.4 15.1v4.2c1 8.5 8.3 15.1 17 15.1h76.6v340.4zM439.6 444.7v-.8.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M580.6 458.2c-89.4 0-161.9 72.5-161.9 161.9S491.2 782 580.6 782s161.9-72.5 161.9-161.9S670 458.2 580.6 458.2zm90.2 252.2c-11.7 11.7-25.4 20.9-40.6 27.4-15.7 6.6-32.4 10-49.7 10s-33.9-3.4-49.7-10c-15.2-6.4-28.9-15.6-40.6-27.4-11.7-11.7-20.9-25.4-27.4-40.6-6.7-15.7-10-32.4-10-49.7 0-17.2 3.4-34 10-49.7 6.4-15.2 15.6-28.8 27.4-40.6 11.7-11.7 25.4-20.9 40.6-27.4 15.7-6.6 32.4-10 49.7-10s33.9 3.4 49.7 10c15.2 6.4 28.8 15.6 40.6 27.4 11.7 11.7 20.9 25.4 27.4 40.6 6.6 15.7 10 32.4 10 49.7 0 17.3-3.4 34-10 49.7-6.5 15.2-15.7 28.9-27.4 40.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera85);
export default ForwardRef;